<template>
  <div class="payment-collect">
    <v-icon class="payment-collect__icon" color="amber accent-2" :size="iconSize">
      mdi-cash-register
    </v-icon>
    <span class="payment-collect__label" :style="{ fontSize: labelSize }">{{ $t("canteen_to_collect") }}:</span> <strong class="payment-collect__amount" :style="{ fontSize: amountSize }">{{ text }}</strong>
  </div>
</template>

<script>
// "Za naplatu: 2650 DIN" na kartici radnika koji plaća na kasi (modul više restorana)
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    food() {
      return this.settings?.font?.size?.food || 24;
    },
    labelSize() {
      return Math.max(18, this.food * 0.85) + "px";
    },
    amountSize() {
      return Math.max(32, this.food * 1.5) + "px";
    },
    iconSize() {
      return Math.max(32, this.food * 1.5);
    },
  },
};
</script>

<style scoped>
.payment-collect {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  margin-top: 16px;
  padding: 14px 20px;
  border-radius: 20px;
  background: #212121;
  color: #fff;
  font-family: "Poppins", Tahoma, sans-serif;
}
.payment-collect__label {
  font-weight: 600;
}
.payment-collect__amount {
  margin-left: auto;
  font-weight: 800;
  line-height: 1.05;
  white-space: nowrap;
}
</style>
